import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import PracticePage from "@/pages/PracticePage";
import CoursesPage from "@/pages/CoursesPage";
import ContactPage from "@/pages/ContactPage";
import PraxisMuensterPage from "@/pages/PraxisMuensterPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContent from "@/pages/admin/AdminContent";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminGallery from "@/pages/admin/AdminGallery";

// Components
import { Layout } from "@/components/Layout";
import { AdminLayout } from "@/components/AdminLayout";
import { AuthProvider } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ScrollToTop } from "@/components/ScrollToTop";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed the database on first load
    const seedDatabase = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        // Database might already be seeded
        console.log("Database seed check complete");
      }
    };
    seedDatabase();
  }, []);

  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/ueber-mich" element={<AboutPage />} />
              <Route path="/therapieangebote" element={<ServicesPage />} />
              <Route path="/praxis-muenster" element={<PraxisMuensterPage />} />
              <Route path="/praxiseinblick" element={<PracticePage />} />
              <Route path="/kursangebote" element={<CoursesPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
            </Route>
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/content" element={<AdminContent />} />
              <Route path="/admin/courses" element={<AdminCourses />} />
              <Route path="/admin/gallery" element={<AdminGallery />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
          <ScrollToTop />
        </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
